import { render, staticRenderFns } from "./wasser.vue?vue&type=template&id=bc15a6b4&"
import script from "./wasser.vue?vue&type=script&lang=js&"
export * from "./wasser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports